import { CSSProperties } from 'react'

const styles: { text: CSSProperties } = {
  text: {
    color: 'white',
  },
}

export default styles
